import { HttpParams } from '@angular/common/http';
import { DataTableQuery } from './data-table.types';

/**
 * Splits a grid query into the POST body and the query string of a `.../datatable` call: the header column
 * filters go out as query parameters (?name=ind&isActive=true, repeated for several values), with the
 * viewer's time zone as ?tz= so a date filter matches the date as the grid shows it. `params` are the
 * page's own parameters (e.g. ?countryId=), kept as they are.
 */
export function dataTableRequest(
  query: DataTableQuery,
  params: HttpParams = new HttpParams()
): { body: DataTableQuery; params: HttpParams } {
  const { columnFilters, ...body } = query;
  let withFilters = params;
  for (const [key, values] of Object.entries(columnFilters ?? {})) {
    for (const value of values) {
      withFilters = withFilters.append(key, value);
    }
  }
  if (withFilters !== params) {
    withFilters = withFilters.set('tz', Intl.DateTimeFormat().resolvedOptions().timeZone);
  }
  return { body, params: withFilters };
}
